import React, { useState, useEffect } from "react"
import { Link } from "gatsby"

import Menu from "./menu"

export default function Header({ darkHeader }) {
    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY >= window.innerHeight)
        onScroll()
        window.addEventListener("scroll", onScroll, { passive: true })
        return () => window.removeEventListener("scroll", onScroll)
    }, [])

    const dark = darkHeader || scrolled

    const menuOpen = () => {
        document.body.classList.add('menu-open')
    }

    return (
        <header className={` ${dark ? " is-dark" : ""}`}>
            <div className='p20 flex align-center space-between'>
                <a href='/' aria-label='Iron Workers'>
                    <div className={`link logo${dark ? " is-dark" : ""}`}/>
                </a>
                <div className='header-nav flex align-center gap-5'>
                    <button type='button' className='button' onClick={menuOpen}>
                        <span className='button-icon menu-icon' aria-hidden='true'/>
                        Menu
                    </button>
                    <div className='m-hide'>
                        <Link to='/contact' className='button link'>
                            Contact
                        </Link>
                    </div>
                </div>
            </div>
        </header>
    )
}
